import axios, { AxiosResponse, ResponseType, AxiosError } from 'axios';
import qs from 'qs';

const DEV_URL = process.env.REACT_APP_API_BASE_URL;

export type HttpMethod = 'get' | 'post' | 'put' | 'delete';

export interface RequestParams {
  method: HttpMethod;
  url: string;
  queryParams?: Record<string, unknown> | any;
  requestBody?: FormData | unknown | string;
  isMultipart?: boolean;
  responseType?: ResponseType;
  hasRoleKey?: boolean;
  headers?: Record<string, any>;
}

export interface PageInfo {
  nextPage?: number;
  isLast?: boolean;
}

export interface Rows<T> extends PageInfo {
  count: number;
  rows: T[];
}

export interface Row<T> {
  row: T;
}

export type AppResponse = AxiosResponse | AxiosError | null;

export const client = axios.create({
  // Timeout 1분
  timeout: 60000,
  paramsSerializer: {
    serialize: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  },
  baseURL: DEV_URL,
});

client.interceptors.request.use((config) => {
  return config;
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    return Promise.reject(err);
  },
);

export const request = async <T>({
  method,
  url,
  queryParams,
  requestBody,
  isMultipart,
  responseType,
  headers: extraHeaders = {},
}: RequestParams): Promise<AxiosResponse<T>> => {
  let headers: Record<string, any> = {
    ...extraHeaders,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  };
  if (isMultipart) {
    headers = { ...headers, 'Content-Type': 'multipart/form-data' };
  }
  let myResponseType: ResponseType = 'json';
  if (responseType) myResponseType = responseType;

  switch (method) {
    case 'get':
      return client.get(url, {
        params: queryParams,
        headers,
        responseType: myResponseType,
      });
    case 'post':
      return client.post(url, requestBody, { params: queryParams, headers });
    case 'put':
      return client.put(url, requestBody, { params: queryParams, headers });
    case 'delete':
      return client.delete(url, { data: requestBody, params: queryParams });
    default:
      return Promise.reject(new Error('Invalid HttpMethod'));
  }
};
